<div class="modal fade" tabindex="-1" [id]="'progressModal'">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div *ngIf="!error && createdNumber!==total || modifyingPackage" class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <i *ngIf="error" class="bi bi-exclamation-triangle-fill fs-1 text-danger"></i>
                <!--<i *ngIf="createdNumber!==total || modifyingPackage"
                    class="bi bi-exclamation-triangle fs-1 text-danger mb-2"></i>-->
                <i *ngIf="createdNumber===total && !modifyingPackage"
                    class="bi bi-check-circle-fill fs-1 text-success mb-2"></i>
                <h4 class="modal-title fw-bold">{{ (head ? head : modifyingPackage? 'LICENSE.MODIFYING':
                    endModify && !modifyingPackage ? 'LICENSE.MODIFIED':
                    createdNumber===total ? 'LICENSE.CREATED':
                    total === 1 ? 'LICENSE.CREATINGSINGULAR':'LICENSE.CREATING') | translate }}</h4>
                <h5 *ngIf="head5" class="modal-title">{{ head5 }}</h5>
            </div>
            <div class="modal-body text-center">
                <div *ngIf="extendedMessage" [innerHTML]="extendedMessage | translate" [class]="innerHTMLStyle"></div>
                <p>{{ '' }}</p>
                <div class="progress-container">
                    <div class="progress-counter">{{createdNumber}} <span> / {{total}}</span></div>
                    <div *ngIf="!error" class="progress-bar">
                        <div class="progress" [style.width]="createdNumber ? (createdNumber!/total!*100)+'%' : '0'">
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!error && createdNumber===total && !modifyingPackage" class="modal-footer">
                <button type="button" class="btn btn-dark" data-bs-dismiss="modal" (click)="confirm.emit()">{{
                    'LICENSE.CONTINUECREATING'
                    | translate }}</button>
                <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" (click)="goList()">{{
                    (endModify || (this.total === 1 && this.createdPackageId)) ?
                    ('LICENSE.GOPACKAGE'|translate):('LICENSE.GOPACKAGELIST' | translate)
                    }}</button>
            </div>
            <div *ngIf="error" class="modal-footer">
                <button type="button" class="btn btn-dark" data-bs-dismiss="modal">{{
                    (cancelText ? cancelText : 'LICENSE.CONTINUECREATING') | translate
                    }}</button>
            </div>
        </div>
    </div>
</div>